export const iconFontAwesomeCampingTent = (
	<i className="fa-solid fa-tent"></i>
);
